import "../home/style.css"

// images
import dob from "../../../../images/DOB.svg"
import smoke from "../../../../images/smoking.svg"
import gender from "../../../../images/sex.svg"
import ethnicity from "../../../../images/ethnicity.svg"
import race from "../../../../images/race.svg"
import { useDispatch, useSelector } from "react-redux"
import moment from "moment"
import { ComponentState, useEffect, useState } from "react"
import { getClientClinic, getClientDoc, getClientSign, getLinkedAccountList, saveDocumentUrl, saveGenericSuccessData } from "../../../../redux/actions"
import { AddSignature } from "./homeComponents/addSignature"
import { Modal } from "@mui/material"
import { UpdatePin } from "./updatePin"
import { PendingDocList } from "./homeComponents/pendingDocList"
import { SignedDocList } from "./homeComponents/signedDocList"
import { MaskFormatted, maskZipCode } from "../../../../utils/mask-helper"
import ViewDocumentFrame from "./homeComponents/viewDocFrame"
import { Appointments } from "../appointments"
import ViewQuestionnaireFrame from "./homeComponents/viewQuestionnaireFrame"
import { PendingquestionnairesList } from "./homeComponents/pendingQuestionnaireList"
import { CompletedquestionnairesList } from "./homeComponents/completedQuestionnaireList"




export const Home = () => {
  const state: ComponentState = useSelector(states => {
    return states;
  });
  const { authClientDetailedInfo, } = state['AuthReducer'];
  const { clientSigns, clientClinicInfo, genericSuccessResp } = state['ClientReducer'];
  const [callInitialApi, setCallInitialApi] = useState(false)
  const [showSignaturePad, setShowSignaturePad] = useState(false)
  const [showPinModel, setShowPinModel] = useState(false)
  const [isParent, setIsParent] = useState(false)
  const [openDocFrame, setOpenDocFrame] = useState(false)
  const [openQueFrame, setOpenQueFrame] = useState(false)
  const [docUrl, setDocUrl] = useState<string>('')
  const [queUrl, setQueUrl] = useState<string>('')
  const [documentId, setSelectedDocumentID] = useState<string>('')
  const [isDocEditable, setDocEditable] = useState<boolean>(true)
  const dispatch = useDispatch()
  const { documentViewUrl, docIsLocked ,isClientFillable} = state['DocumentReducer'];
  const [clientSignature, setClientSignature] = useState<any>();
  const [parentSignature, setParentSignature] = useState<any>();

  useEffect(() => {
    if (!callInitialApi) {
      dispatch(getClientSign())
      dispatch(getClientClinic())
      setCallInitialApi(true)
    }
  }, [callInitialApi])


  useEffect(() => {
    if (documentViewUrl && documentViewUrl != null) {
      const searchParams = new URLSearchParams(documentViewUrl)
      if(searchParams.get('queId') !== "null" && searchParams.get('queId') !== "undefined" && searchParams.get('queId') !== '') {
        setQueUrl(documentViewUrl)
      }
      else if (searchParams.get('docId')) {
        setSelectedDocumentID(searchParams.get('docId')!)
        setDocEditable(parseInt(searchParams.get('editable')!) == 1)
        setDocUrl(`${documentViewUrl}`)
        }
           dispatch(saveDocumentUrl())
          }
  }, [documentViewUrl])


  useEffect(() => {


    if (docUrl.length > 0) {
      setOpenDocFrame(true)
    }
  }, [docUrl])

  useEffect(() => {
    if (queUrl.length > 0) {
      setOpenQueFrame(true)
    }
  }, [queUrl])

  useEffect(() => {
    if (clientSigns) {
      dispatch(saveGenericSuccessData(false))
      setShowSignaturePad(false)
      setParentSignature(clientSigns.find((element: any) => {
        return element.isParentSig === true;
      }))

      setClientSignature(clientSigns.find((element: any) => {
        return element.isParentSig === false;
      }))
    }
  }, [clientSigns])





  return <>
    <section className="dashboard-wrapper pt-4 mt-5">
      <Modal
        open={showSignaturePad}
        onClose={() => { }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <AddSignature isParent={isParent} clientID={authClientDetailedInfo.clientId} title='Add Client Signature' onClose={() => setShowSignaturePad(false)} />
        </div>
      </Modal>

      <Modal
        open={showPinModel}
        onClose={() => { }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <UpdatePin isParent={isParent} clientID={authClientDetailedInfo.clientId} title='Change Signature PIN' onClose={() => setShowPinModel(false)} />
        </div>
      </Modal>

      <Modal
        open={openDocFrame}
        onClose={() => { setOpenDocFrame(false) }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <ViewDocumentFrame
            isSignedDoc={!isDocEditable}
            url={docUrl}
            docId={parseInt(documentId)}
            cancelClick={() => setOpenDocFrame(false)}
            isLocked={docIsLocked}
            isClientFillable={isClientFillable}

          ></ViewDocumentFrame>
        </div>
      </Modal>

      <Modal
        open={openQueFrame}
        onClose={() => { setOpenQueFrame(false) }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <ViewQuestionnaireFrame
            url={queUrl}
            cancelClick={() => setOpenQueFrame(false)}
          ></ViewQuestionnaireFrame>
        </div>
      </Modal>

    </section>

    <section className="info-wrapper my-5">

      <div className="container-fluid">
        <div>
          <div className="row m-0">
            <div className="col-lg-6 col-sm-12">
              <div className="patient-info">
                <h3 className="mb-3">Client Information</h3>

                <div className="bg-white border30 boxShadow">
                  <h3 className="teal fw-600 mt-2 pl-3 pt-4">{authClientDetailedInfo.fName && `${authClientDetailedInfo.fName} ${authClientDetailedInfo.lName}`}</h3>
                  {/* {(isUserAParent && linkedAccountsListData?.resultData?.length>0) && <li className="menu-item info-list my-3 px-3">
                    <span className="menu-name">Linked Clients</span>
                    {
                      linkedAccountsListData?.resultData?.map((dataItem: any) => {
                        return <div
                        className="td_link_bg_theme"
                        onClick={() => {
                          seSelectedClient(dataItem)
                          setOpenDialog(true)
                        }}>

                          <p className="fw-500" >{`${dataItem.lName}, ${dataItem.fName}`}
                          <i className="fa fa-angle-right ml-2"></i></p>
                        </div>

                      })
                    }


                  </li>
                  } */}

                  <ul className="info-list my-3 px-3">
                    <li className="col-md-4 px-0 fw-500 col-12">{authClientDetailedInfo.homeAddress && `${authClientDetailedInfo.homeAddress} ${(authClientDetailedInfo.homeAddress2) ? authClientDetailedInfo.homeAddress2 : ''}`} </li>
                    <li className="col-md-4 px-0 fw-500 col-12">{authClientDetailedInfo.homeCity && `${authClientDetailedInfo.homeCity}, ${authClientDetailedInfo.homeStateName && authClientDetailedInfo.homeStateName} ${authClientDetailedInfo.homeZip && maskZipCode(authClientDetailedInfo.homeZip)}`} </li>
                  </ul>



                  <div className="row m-0 rowgap py-4">
                    <div className="col-lg-6 col-md-6 col-sm-12 ">
                      <div className="d-flex align-items-center gap-2 bg-white p-3 parent-info-list">
                        <img src={dob} />
                        <p className="fw-500">DOB: <span className="fw-600">{authClientDetailedInfo.dob ? moment(authClientDetailedInfo.dob).format('MM/DD/YYYY') : 'N/A'}</span></p>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 ">
                      <div className="d-flex align-items-center gap-2 bg-white p-3 parent-info-list">
                        <img src={smoke} />
                        <p className="fw-500">Smoking Status<span className="fw-600">: {authClientDetailedInfo.smokingStatus ? authClientDetailedInfo.smokingStatus : 'N/A'}</span></p>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 ">
                      <div className="d-flex align-items-center gap-2 bg-white p-3 parent-info-list">
                        <img src={gender} />
                        <p className="fw-500">Sex:  <span className="fw-600">{authClientDetailedInfo.gender ? authClientDetailedInfo.gender : 'N/A'}</span></p>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <div className="d-flex align-items-center gap-2 bg-white p-3 parent-info-list">
                        <img src={ethnicity} />
                        <p className="fw-500">Ethnicity: <span className="fw-600">{authClientDetailedInfo.ethnicityName ? authClientDetailedInfo.ethnicityName : 'N/A'}</span></p>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 ">
                      <div className="d-flex align-items-center gap-2 bg-white p-3 parent-info-list">
                        <img src={race} />
                        <p className="fw-500">Race: <span className="fw-600">{authClientDetailedInfo.race ? authClientDetailedInfo.race : 'N/A'}</span></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-sm-12 ">
              <div className="patient-info">
                <h3 className="mb-3">Clinic Information</h3>

                <div className="bg-white px-3 p-3 pb-2 border30 boxShadow">
                  <h3 className="teal fw-600 mb-3">{clientClinicInfo.clinicName && clientClinicInfo.clinicName}</h3>
                  <ul className="info-list ">
                    <li className="col-md-4 px-0 fw-500 col-12">{clientClinicInfo.address && clientClinicInfo.address} </li>
                    <li className="col-md-4 px-0 fw-500 col-12">{clientClinicInfo.city && `${clientClinicInfo.city}, ${clientClinicInfo.state && clientClinicInfo.state} ${clientClinicInfo.zip && maskZipCode(clientClinicInfo.zip)}`} </li>
                    <li className="col-md-4 px-0 fw-500 col-12"><i className="fa-solid fa-phone mr-1"></i> {clientClinicInfo.phone && `${MaskFormatted(clientClinicInfo.phone, '(000) 000-0000')}`} </li>
                  </ul>
                </div>
              </div>
              <div className="signature-wrapper mt-4">
                <div className="row m-0">
                  <div className="col-lg-6 col-sm-12 sm-paadding-0">
                    <div className="patient-info ">
                      <h3>Client Signature </h3>

                      <div className="client-signature boxShadow">
                        <div>
                          <div className="sign-fixed-height text-center">
                            {
                              (clientSignature && clientSignature.signBytes) &&
                              // clientSigns.map((obj: ClientSignatureResp, index:number) => (
                              <div
                                className="d-flex justify-content-center align-items-center  p-3 "
                              >


                                <img
                                  className="signImage"
                                  alt="demo"
                                  src={"data:image/png;base64," + clientSignature.signBytes}
                                />
                              </div>

                              // ))
                            }
                          </div>

                          {(clientSignature && clientSignature.signBytes) ?
                            <div className="client-button gap-2 mt-4 justify-content-center">
                              <button
                                className="btn-common btn-green" onClick={() => {
                                  setIsParent(false)
                                  setShowSignaturePad(true)
                                }
                                }>Update Signature</button>
                              <button className="btn-common white-btn"
                                onClick={() => {
                                  setIsParent(false)
                                  setShowPinModel(true)
                                }
                                }
                              >Change PIN?</button>
                            </div> : <div className="client-button gap-2 justify-content-center">
                              <button className="btn-common btn-green"
                                onClick={() => {
                                  setIsParent(false)
                                  setShowSignaturePad(true)
                                }
                                }
                              >Add Signature</button></div>
                          }
                        </div>
                      </div>

                    </div>
                  </div>

                  <div className="col-lg-6 col-sm-12 sm-paadding-0 ">
                    <div className="patient-info">
                      <h3>Parent Signature</h3>

                      <div className="client-signature boxShadow" >
                        <div>

                          <div className="sign-fixed-height text-center">
                            {
                              (parentSignature && parentSignature.signBytes) &&
                              // clientSigns.map((obj: ClientSignatureResp, index:number) => (
                              <div
                                className="d-flex justify-content-center align-items-center  p-3 "
                              >


                                <img
                                  className="signImage"
                                  alt="demo"
                                  src={"data:image/png;base64," + parentSignature.signBytes}
                                />

                              </div>

                              // ))
                            }

                          </div>


                          {(parentSignature && parentSignature.signBytes) ?
                            <div className="client-button gap-2  mt-4 justify-content-center">
                              <button className="btn-common btn-green" onClick={() => {
                                setIsParent(true)
                                setShowSignaturePad(true)
                              }
                              }> Update Signature</button>
                              <button className="btn-common white-btn"
                                onClick={() => {
                                  setIsParent(true)
                                  setShowPinModel(true)
                                }
                                }
                              >Change PIN?</button>
                            </div> : <div className="client-button gap-2 justify-content-center">
                              <button className="btn-common btn-green" onClick={() => {
                                setIsParent(true)
                                setShowSignaturePad(true)
                              }
                              }> Add Signature</button></div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div className="col-lg-6 col-sm-12 sm-paadding-0" style={{ marginTop: 20 }}>
              <div className="patient-info">
                <section className="listtabs mb-5 ">
                  <div className="container-fluid">
                    <div className="list-tab-wrapper sm-paadding-0">
                      <ul className="nav nav-tabs mb-2" role="tablist">
                        <li className="nav-item">
                          <a className="nav-link active boxShadow" data-toggle="tab" href="#tabs-1" role="tab">Pending Documents</a>
                        </li>
                        <li className="nav-item">
                          <a className="nav-link boxShadow" data-toggle="tab" href="#tabs-2" role="tab">Completed Documents</a>
                        </li>
                      </ul>
                      <div className="tab-content boxShadow">
                        <div className="tab-pane home-plan-head active" id="tabs-1" role="tabpanel">
                          <table className="table">
                            <PendingDocList></PendingDocList>
                          </table>
                        </div>
                        <div className="tab-pane home-plan-head" id="tabs-2" role="tabpanel">
                          <table className="table">
                            <SignedDocList></SignedDocList>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div></div>

            <div className="col-lg-6 col-sm-12 sm-paadding-0" style={{ marginTop: 20 }}>
              <div className="patient-info">
                <section className="listtabs mb-5 ">
                  <div className="container-fluid">
                    <div className="list-tab-wrapper sm-paadding-0">
                      <ul className="nav nav-tabs mb-2" role="tablist">


                        <li className="nav-item">
                          <a className="nav-link active boxShadow" data-toggle="tab" href="#tabs-3" role="tab">Pending Questionnaire</a>
                        </li>

                        <li className="nav-item">
                          <a className="nav-link boxShadow" data-toggle="tab" href="#tabs-4" role="tab">Completed Questionnaire</a>
                        </li>
                      </ul>
                      <div className="tab-content boxShadow">

                        <div className="tab-pane home-plan-head active" id="tabs-3" role="tabpanel">
                          <table className="table">
                            <PendingquestionnairesList />
                          </table>
                        </div>

                        <div className="tab-pane home-plan-head" id="tabs-4" role="tabpanel">
                          <table className="table">
                            <CompletedquestionnairesList />
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div></div>



            <div className="col-lg-6 col-sm-12" style={{ marginTop: 20 }}>
              <div className="patient-info">
                <Appointments isHomeScreen={true}></Appointments>
              </div></div>

          </div>

        </div>
      </div>
    </section>

  </>
}